import type { FaireProductEntity } from "../../entity_types/product";

export const p_bnmdxcq7je: FaireProductEntity = {
  token: "p_bnmdxcq7je",
  type: "product",
  name: "Como Tealight and Taper Candle Holder",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/4429165e75139e6f3f7989aebe3ba6544102e67516ec4b01528823758fbd59ea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fd205445fa82758e478aa24b077eb2804aeb16295c6ea04b20d1fa9d2deeb443.jpeg",
    "https://cdn.faire.com/fastly/3792849cf96a30f36e5bb107d0db22af338e5e58c252ab30403bf39727984dd6.jpeg",
    "https://cdn.faire.com/fastly/1818b2aa4bf48dfb15ee2221a38f392cbcf74bbb03e6812ee68b73ba94256dbf.jpeg",
    "https://cdn.faire.com/fastly/1a6bad122347e1a3a24a0561a394db0aba2fd42bea41b6ec3f84fe624bdb2153.jpeg",
    "https://cdn.faire.com/fastly/e139659845baadfad7b0cb1ab25b9b8cbe00060abf10552b1cd87069477612a2.jpeg",
    "https://cdn.faire.com/fastly/860e1bbc81c79004d02bcb67daf36292a924708618de28f3c7c7adf098b7aca2.jpeg",
    "https://cdn.faire.com/fastly/c531c0c23647f5e0ba2b4abdd4dd18cb64e793cc42a35b656f82f056dff1fdba.jpeg",
  ],
  priceDollars: 16,
  description:
    "Please note that Como candleholders in Deep Black will be shipped from our UK location.\n\nComo candle holder has been thoughtfully designed to accommodate both tealights and tapered candles which allows more styling options.\nAvailable in two beautiful marble varieties in a honed finish will add substance and rich materiality to your home.\n\n𝐏𝐫𝐨𝐝𝐮𝐜𝐭 𝐢𝐧𝐟𝐨𝐫𝐦𝐚𝐭𝐢𝐨𝐧\n\nPlease note that due to the nature of the material, colour and pattern variation will occur. Giving you a truly unique piece. Our photos should be used as a guide.\n\n• Dimensions: H78 x D55mm\n• Material: Marble",
  tags: [],
  msrpDollars: 32,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:19.346Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
